export default {
  FB: "https://connect.facebook.net/en_US/sdk.js",
  gapi: "https://apis.google.com/js/platform.js",
  gapiConditions: {
    apiKey: "AIzaSyD7T8-M5Sb5j_8IStn8bDw9wIap4JMDBTs",
    clientId:
      "233523816833-oak59ckdrn29uudb7b37qtmnckht0604.apps.googleusercontent.com",
    scope: "profile email openid"
  }
};
